import { useCallback, useEffect, useState } from 'react'
import { apiRequest } from './supportApi'

/** Fired by ClientTicketChat after it marks messages as read, so badges refresh right away. */
export const UNREAD_CHANGED_EVENT = 'client-tickets-unread-changed'

const POLL_MS = 60000

/**
 * Unread client-ticket messages for a header badge.
 *   customer: '/portal/api/client-tickets/unread/'
 *   staff:    '/portal/api/client-tickets/manage/unread/'
 * Polls every minute (paused while the tab is hidden), and refreshes when the tab
 * regains focus or a chat reports that messages were read.
 */
export function useUnreadCount(path: string, enabled = true): number {
    const [count, setCount] = useState(0)

    const refresh = useCallback(async () => {
        if (!enabled || document.hidden) return
        const { ok, data } = await apiRequest<{ unread_count: number }>(path)
        if (ok) setCount(data?.unread_count ?? 0)
    }, [path, enabled])

    useEffect(() => {
        if (!enabled) { setCount(0); return }
        refresh()
        const timer = window.setInterval(refresh, POLL_MS)
        window.addEventListener(UNREAD_CHANGED_EVENT, refresh)
        window.addEventListener('focus', refresh)
        return () => {
            window.clearInterval(timer)
            window.removeEventListener(UNREAD_CHANGED_EVENT, refresh)
            window.removeEventListener('focus', refresh)
        }
    }, [enabled, refresh])

    return count
}

/** "99+" for big numbers */
export const badgeText = (n: number) => (n > 99 ? '99+' : String(n))